import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class EmploiResolver  {
    constructor(private http: HttpClient, private router: Router) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const id = route.params['id'];
        return this.http.get(`assets/donnees/emplois/${id}.json`).pipe(
            catchError( erreurs => {
                const URLLangue = 'offresemploi';
                this.router.navigate([URLLangue]);
                return EMPTY;
            }));
    }
}
